import { portalBoardUrl } from '../../clientPortal/portalEntry';
import '../../styles/signatureRetry.css';

export type SignatureRetryVariant = 'cancelled' | 'technical';

type SignatureRetryNoticeProps = {
  quoteId: string;
  onRetry: () => void;
  /** `cancelled` is the client walking away. `technical` is a Logalty/provider failure. */
  variant?: SignatureRetryVariant;
  /** BR copy uses você. MX/INT stay in Spanish with tú. */
  language?: 'es' | 'pt';
};

const COPY = {
  es: {
    cancelled: {
      title: 'La firma no se completó',
      body: 'Cancelaste o rechazaste la firma. Tu solicitud sigue abierta: puedes volver a firmar cuando quieras.',
    },
    technical: {
      title: 'No pudimos conectar con la firma',
      body: 'Hubo un problema técnico y la firma no se completó. Tu solicitud sigue abierta: puedes intentarlo de nuevo.',
    },
    retry: 'Reintentar firma',
    board: 'Ver el estado de mi solicitud',
  },
  pt: {
    cancelled: {
      title: 'A assinatura não foi concluída',
      body: 'Você cancelou ou recusou a assinatura. Sua solicitação continua aberta: você pode assinar de novo quando quiser.',
    },
    technical: {
      title: 'Não conseguimos conectar com a assinatura',
      body: 'Houve um problema técnico e a assinatura não foi concluída. Sua solicitação continua aberta: você pode tentar de novo.',
    },
    retry: 'Tentar assinar de novo',
    board: 'Ver o estado da minha solicitação',
  },
} as const;

/**
 * Shown when the ceremony must not start on its own.
 * The ceremony starts only from the button — never from mounting this screen.
 */
const SignatureRetryNotice = ({
  quoteId,
  onRetry,
  variant = 'cancelled',
  language = 'es',
}: SignatureRetryNoticeProps) => {
  const copy = COPY[language];
  const message = copy[variant];

  return (
    <div className="mx-firma-reintento" data-testid="mx-firma-reintento">
      <h1 data-testid="mx-firma-reintento-titulo">{message.title}</h1>
      <p data-testid="mx-firma-reintento-texto">{message.body}</p>
      <div className="mx-firma-reintento-actions">
        <button
          type="button"
          className="mx-firma-reintento-boton"
          data-testid="mx-firma-reintento-boton"
          onClick={onRetry}
        >
          {copy.retry}
        </button>
        <a
          className="mx-firma-reintento-link"
          data-testid="mx-firma-reintento-tablero"
          href={portalBoardUrl(quoteId)}
        >
          {copy.board}
        </a>
      </div>
    </div>
  );
};

export default SignatureRetryNotice;
